import {marked} from "marked";
import {LegalPage} from "~/components/legalPage";
import source from "~/content/legal/privacy-policy.md?raw";

const html = marked.parse(source, {async: false});

export function meta() {
    return [{title: "Privacy Policy, Intellsys OS"}];
}

export default function RouteComponent() {
    return (
        <LegalPage
            title="Privacy Policy"
            html={html}
        />
    );
}
